module.exports = __webpack_public_path__ + "static/img/calvert-logo.5b96ce4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/calvert-logo.png
// module id = 229
// module chunks = 1